<!--
 * @Author: lsq
 * @Date: 2024-03-12 11:24:01
 * @LastEditTime: 2024-11-13 16:51:17
 * @LastEditors: lsq
 * @Description: 
 * @FilePath: /sunpay-web/src/components/common/PasswordInput.vue
-->

<template>
  <el-input
    v-bind="attrs"
    class="tm-password-input"
    v-model="state.value"
    :type="state.show ? 'test' : 'password'"
    @input="handleChange"
  >
    <template #append>
      <el-icon @click="state.show = !state.show">
        <View v-if="state.show" />
        <Hide v-else />
      </el-icon>
    </template>
  </el-input>
</template>

<script setup>
import { reactive, useAttrs, watch } from "vue"
import { Hide, View } from "@element-plus/icons-vue"

const props = defineProps({
  modelValue: {
    type: [String, Number],
  },
})
const emit = defineEmits(["update:modelValue", "change"])
const attrs = useAttrs()
const state = reactive({
  show: false,
  value: props.modelValue,
})

watch(
  () => props.modelValue,
  newVal => {
    state.value = newVal
  }
)

const handleChange = val => {
  emit("update:modelValue", val)
  emit("change", val)
}
</script>

<style lang="less" scoped>
:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px var(--el-input-border-color) inset;
}
:deep(.el-input-group__append) {
  background: #fff;
  margin-left: -2px;
}
</style>
<style lang="less">
.el-form-item.is-error .el-input-group__append {
  box-shadow: 0 1px 0 0 var(--el-color-danger) inset, 0 -1px 0 0 var(--el-color-danger) inset,
    -1px 0 0 0 var(--el-color-danger) inset;
}
.is-error {
  .el-input-group--append.tm-password-input:hover {
    .el-input__wrapper {
      box-shadow: 0 0 0 1px var(--el-color-danger) inset;
    }
    .el-input-group__append {
      box-shadow: 0 1px 0 0 var(--el-color-danger) inset, 0 -1px 0 0 var(--el-color-danger) inset,
        -1px 0 0 0 var(--el-color-danger) inset;
    }
  }
}

.el-input-group--append.tm-password-input:hover {
  .el-input__wrapper {
    box-shadow: 0 0 0 1px var(--el-input-hover-border-color) inset;
  }
  .el-input-group__append {
    box-shadow: 0 1px 0 0 var(--el-input-hover-border-color) inset,
      0 -1px 0 0 var(--el-input-hover-border-color) inset,
      -1px 0 0 0 var(--el-input-hover-border-color) inset;
  }
}
</style>
